/*
    UI komponenta ProgressBar

    Povinné data atributy example:

    <div class="progress-bar" data-progress-bar>
        <div class="progress-bar__indicator" data-progress-bar-indicator></div>
    </div>

    Popis:
    Komponenta ProgressBar vizualizuje průběh načítání pomocí animovaného indikátoru.
    Automaticky se spustí po připojení k DOM a simuluje průběh načítání do 90 %,
    poté čeká na událost "load" pro dokončení na 100 %.

    API:
    - start(): Restartuje progress bar a začne simulované načítání.
    - complete(): Okamžitě dokončí animaci na 100 % a skryje progress bar.
*/

export const ProgressBar = (element: HTMLElement) => {
  let progress: number = 0;
  let intervalId: number | null = null;

  // Najde indikátor průběhu uvnitř zadaného elementu
  const progressIndicator = element.querySelector('[data-progress-bar-indicator]') as HTMLElement;
  if (!progressIndicator) {
    throw new Error(
      'Progress bar indicator with [data-progress-bar-indicator] attribute not found'
    );
  }

  // Aktualizuje šířku indikátoru podle aktuálního průběhu
  const update = (): void => {
    progressIndicator.style.width = `${progress}%`;
  };

  // Spustí simulované načítání a postupně zvyšuje hodnotu progressu do 90 %
  const start = (): void => {
    progress = 0;
    update();

    // Simuluje průběh až do 90 %
    intervalId = window.setInterval(() => {
      if (progress < 90) {
        progress += Math.random() * 10;
        if (progress > 90) progress = 90;
        update();
      }
    }, 500);
  };

  // Dokončí animaci na 100 %, zastaví interval a po krátké chvíli skryje progress bar
  const complete = (): void => {
    if (intervalId) {
      window.clearInterval(intervalId);
      intervalId = null;
    }

    progress = 100;
    update();

    // Skryje progress bar po dokončení
    setTimeout(() => {
      element.classList.add('progress-bar--complete');
    }, 1000);
  };

  // Spustí progress bar ihned po vytvoření komponenty
  start();

  // Po načtení stránky dokončí animaci na 100 %
  window.addEventListener('load', () => {
    complete();
  });

  // Vrátí metody pro případné externí použití
  return {
    start,
    complete,
  };
};
